import { useMedia } from 'react-use';

import { mediumDesktopAndAbove } from 'style/mediaQuery';

export const useIsMediumDesktopAndAbove = () => useMedia(mediumDesktopAndAbove);
